var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 .75a.75.75 0 0 0 0 1.5h3.385l.873 4.362.015.071 1.671 8.353v.001a2.75 2.75 0 0 0 2.743 2.213h9.706a2.75 2.75 0 0 0 2.743-2.214v-.005l1.6-8.39A.75.75 0 0 0 23 5.75H6.616l-.88-4.397A.75.75 0 0 0 5 .75zm7.415 13.993-1.5-7.493h15.179l-1.43 7.494v.002a1.25 1.25 0 0 1-1.25 1.004H9.666a1.25 1.25 0 0 1-1.25-1.006zM8.75 23a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m12 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
    clipRule: "evenodd"
  })));
};
export default SvgCart;